module.exports = __webpack_public_path__ + "img/t.fc02a505.svg";